import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const AuthLayout = ({ sidebarTitle, sidebarTagline, children }) => {
    return (
        <Box
            component="main"
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 'calc(100vh - 128px)', // Adjust based on header/footer height
                p: { xs: 2, sm: 3 },
                backgroundColor: 'background.default',
            }}
        >
            <Paper
                elevation={8}
                sx={{
                    display: 'flex',
                    width: { xs: '100%', sm: '90%', md: '75%', lg: '60%' },
                    maxWidth: '900px',
                    overflow: 'hidden',
                    borderRadius: 2,
                    boxShadow: (theme) =>
                        theme.palette.mode === 'dark'
                            ? `0 8px 32px 0 ${theme.palette.primary.main}33`
                            : theme.shadows[8],
                }}
            >
                {/* Sidebar */}
                <Box
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: 2,
                        width: '40%',
                        p: 5,
                        color: 'primary.contrastText',
                        backgroundColor: 'primary.main',
                    }}
                >
                    <Typography variant="h4" component="h1" fontWeight={700}>
                        {sidebarTitle}
                    </Typography>
                    <Typography variant="body1" sx={{ opacity: 0.8 }}>
                        {sidebarTagline}
                    </Typography>
                </Box>

                {/* Form Content */}
                <Box sx={{ flex: 1, p: { xs: 3, sm: 5 } }}>{children}</Box>
            </Paper>
        </Box>
    );
};

export default AuthLayout;